/* =========================================================
   DEKOFAR PRODUCT SYSTEM V2
   CAMPAIGN JAVASCRIPT

   İçerik:
   - Kampanya geri sayımı
   - Süre bitince kampanya alanını kaldırma
   ========================================================= */


/* =========================================================
   CAMPAIGN COUNTDOWN
   ========================================================= */

function dekofarV2InitCampaignCountdown(
  scope
) {
  const root =
    scope || document;

  root
    .querySelectorAll(
      '[data-dekofar-v2-campaign]'
    )
    .forEach(
      (campaign) => {

        if (
          campaign.dataset
            .dekofarV2CampaignInitialized ===
          'true'
        ) {
          return;
        }


        const endTimestamp =
          parseInt(
            campaign.getAttribute(
              'data-campaign-end'
            ),
            10
          );


        if (
          !endTimestamp ||
          Number.isNaN(
            endTimestamp
          )
        ) {
          return;
        }


        campaign.dataset
          .dekofarV2CampaignInitialized =
          'true';


        const daysElement =
          campaign.querySelector(
            '[data-campaign-days]'
          );


        const hoursElement =
          campaign.querySelector(
            '[data-campaign-hours]'
          );


        const minutesElement =
          campaign.querySelector(
            '[data-campaign-minutes]'
          );


        const secondsElement =
          campaign.querySelector(
            '[data-campaign-seconds]'
          );


        const formatNumber =
          (number) => {
            return String(
              number
            ).padStart(
              2,
              '0'
            );
          };


        const updateCountdown =
          () => {

            const now =
              Math.floor(
                Date.now() / 1000
              );


            const remaining =
              endTimestamp - now;


            if (
              remaining <= 0
            ) {

              if (
                campaign
                  .dekofarV2CampaignInterval
              ) {
                clearInterval(
                  campaign
                    .dekofarV2CampaignInterval
                );
              }


              campaign.remove();

              return;
            }


            const days =
              Math.floor(
                remaining / 86400
              );


            const hours =
              Math.floor(
                (
                  remaining % 86400
                ) / 3600
              );


            const minutes =
              Math.floor(
                (
                  remaining % 3600
                ) / 60
              );


            const seconds =
              remaining % 60;


            if (
              daysElement
            ) {
              daysElement.textContent =
                formatNumber(
                  days
                );
            }


            if (
              hoursElement
            ) {
              hoursElement.textContent =
                formatNumber(
                  hours
                );
            }


            if (
              minutesElement
            ) {
              minutesElement.textContent =
                formatNumber(
                  minutes
                );
            }


            if (
              secondsElement
            ) {
              secondsElement.textContent =
                formatNumber(
                  seconds
                );
            }

          };


        updateCountdown();


        campaign
          .dekofarV2CampaignInterval =
          setInterval(
            updateCountdown,
            1000
          );

      }
    );
}